import ImmutableModel from '../immutable.model';

class Address extends ImmutableModel {
  /**
   * @param {String} street
   * @param {String} postal_code
   * @param {String} postal_area
   * @param {?Coordinates} coordinates
   * @param {?String} country
   * @param {?String} place_id Google Maps place ID
   */
  constructor(
    street,
    postal_code,
    postal_area,
    coordinates=null,
    country=null,
    place_id=null
  ) {
    super();

    this.street = street;
    this.postal_code = postal_code;
    this.postal_area = postal_area;
    this.coordinates = coordinates;
    this.country = country;
    this.place_id = place_id;
  }

  copy() {
    return new Address(
      this.street,
      this.postal_code,
      this.postal_area,
      this.coordinates,
      this.country,
      this.place_id
    );
  }

  toString() {
    return `${this.street}, ${this.postal_code} ${this.postal_area}`;
  }
}

/**
 * A type definition for coordinates to simplify their usage in doc blocks.
 * @typedef {{lat: Number, lon: Number}} Coordinates
 */

export default Address;



// WEBPACK FOOTER //
// ./src/app/common/models/address.model.js